import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core'

@Directive({ selector: '[anchor-bottom]' })
export class AnchorBottomDirective implements OnInit {
  constructor(
    private _elemRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  ngOnInit() {
    const obs = new ResizeObserver(() => {
      const elementBottom = this._elemRef.nativeElement.getBoundingClientRect().bottom
      const viewportBottom = window.visualViewport!.height

      if (elementBottom > viewportBottom) this._renderer.setStyle(this._elemRef.nativeElement, 'bottom', '30px')
    })

    obs.observe(this._elemRef.nativeElement)
  }
}
